import { defineComponent as _defineComponent } from 'vue'
import MyProjectsSectionHeader from '@/views/my-projects/components/MyProjectsSectionHeader.vue';
import MyProjectsContractBaseDataPartner from '@/views/my-projects/components/contract/base-data/MyProjectsContractBaseDataPartner.vue';
import MyProjectsContractBaseDataOffer from '@/views/my-projects/components/contract/base-data/MyProjectsContractBaseDataOffer.vue';
import BCXHelpTextTriggerIcon from '@/components/molecules/BCXHelpTextTriggerIcon.vue';
import { ref } from 'vue';
import BCXInfoCollapsible from '@/components/molecules/BCXInfoCollapsible.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyProjectsContractBaseData',
  setup(__props) {


const isHelpOpen = ref(false);


return { __sfc: true,isHelpOpen, MyProjectsSectionHeader, MyProjectsContractBaseDataPartner, MyProjectsContractBaseDataOffer, BCXHelpTextTriggerIcon, BCXInfoCollapsible }
}

})